import { render, staticRenderFns } from "./crack.vue?vue&type=template&id=68ce3461&scoped=true&"
import script from "./crack.vue?vue&type=script&lang=js&"
export * from "./crack.vue?vue&type=script&lang=js&"
import style1 from "./crack.vue?vue&type=style&index=1&id=68ce3461&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce3461",
  null
  
)

export default component.exports